
import { useNavigate } from '@/composable';
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'ButtonItem',
  props: {
    title: String,
    isShowLineButtom: Boolean,
    iconRsc: String,
    href: String,
    url: String,
    taget: String
  },
  setup(props) {
    const { navigate } = useNavigate();

    const arrowIcon = computed(() => {
      return props.iconRsc || require('@/assets/svg/service-arrow-right.svg');
    });
    const titleButton = computed(() => {
      return props.title || '詳しく見る';
    });
    const taget = computed(() => {
      return props.taget || '_blank';
    });
    const onClick = () => {
      if (props.url) {
        navigate(props.url, taget.value === '_blank' ? 'window' : 'router');
      }
    };
    return {
      arrowIcon,
      titleButton,
      onClick
    };
  }
});
